import React, { useState, useEffect } from "react";
import {
  Navbar,
  Categories,
  DisplayCategories,
  Footer,
  MainBanners,
  Banners,
} from "../Components";
import axiosConfig from "../Service/axiosConfig";
import "./Pages.css";
import ImageGrid from "./ImageGrid";
import ProductGrid from "../Components/Sectionfooter/GridData";
import MiddleBanner from "./MiddleBanner";

const Home = () => {
  const [Login, Setlogin] = useState(false);
  const [siteData, setSiteData] = useState({});
  const [components, setComponents] = useState([]);

  const GetData = async () => {
    try {
      const response = await axiosConfig.get("/cms/get_homepagedesign/");
      let data = response.data.results;
      console.log(data, "hhh");
      const combinedData = [
        ...data
          .filter((item) => item.title === "Banner Slider")
          .map((item) => ({
            type: "Banners",
            content: item.slider,
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "Full Width Banner")
          .map((item) => ({
            type: "MainBanners",
            content: item.banner,
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "Categorie")
          .map((item) => ({
            type: "Categories",
            content: item.category,
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "Products")
          .map((item) => ({
            type: "Products",
            content: item.subcategory,
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "One By Two Banners")
          .map((item) => ({
            type: "One By Two Banners",
            content: item.onebytwo_banners,
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "Vertical Banners")
          .map((item) => ({
            type: "Vertical Banners",
            content: item.vertical_banners,
            subcategory: item.vertical_banners.map((item) => item.subcategory),
            sort: item.sort,
          })),
        ...data
          .filter((item) => item.title === "Middle Banners")
          .map((item) => ({
            type: "Middle Banners",
            content: item.middle_banners,
            sort: item.sort,
          })),
      ];

      combinedData.sort((a, b) => a.sort - b.sort);
      setComponents(combinedData);
    } catch (error) {
      console.error("Error fetching homepage design:", error);
    }
  };
  console.log(components, "cc");
  useEffect(() => {
    GetData();
  }, []);

  return (
    <>
      <div className="navbar-section">
        <Navbar LoginAccount={Login} />
      </div>

      {components.map((item, index) => {
        if (item.type === "MainBanners") {
          return <MainBanners key={index} data={item.content} />;
        }

        if (item.type === "Banners") {
          return <Banners key={index} data={item.content} />;
        }
        if (item.type === "Categories") {
          return (
            <div className="categories-section">
              <Categories key={index} data={item.content} />
            </div>
          );
        }
        if (item.type === "Products") {
          return (
            <div className="display-categories-section">
              <DisplayCategories
                Setlogin={Setlogin}
                LoginAccount={Login}
                key={index}
                data={item.content}
              />
            </div>
          );
        }
        if (item.type === "One By Two Banners") {
          return <ImageGrid key={index} data={item.content} />;
        }
        if (item.type === "Vertical Banners") {
          return (
            <ProductGrid
              key={index}
              data={item.content}
              subcategory={item.subcategory}
            />
          );
        }
        if (item.type === "Middle Banners") {
          return <MiddleBanner key={index} data={item.content} />;
        }
        return null;
      })}

      {/* <ProductGrid /> */}
      <div className="footer-section">
        <Footer />
      </div>
    </>
  );
};

export { Home };
